
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import MDTypography from 'components/MDTypography';
import {
    getFundingSourceList,
    deleteFundingSource,
    deleteFundingSourceRequest,
    getDeactivatedUsersList
} from 'store/reducers/fundingSourceSlice';
import { Box } from '@mui/material';

const useFundingSourceHook = () => {
    const dispatch = useDispatch();
    const { fundingSourceList } = useSelector((state) => state.fundingSource);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [perPage, setPerPage] = useState(10);
    const [isRemovalModal, setIsRemovalModal] = useState(false);
    const [isDeclineModal, setIsDeclineModal] = useState(false);
    const [saveFundingSourceId, setSaveFundingSourceId] = useState(null);
    const [isFundingSourceLoading, setIsFundingSourceLoading] = useState(false);

    const closeRemovalModal = () => {
        setIsRemovalModal(false);
    }

    const closeDeclineModal = () => {
        setIsDeclineModal(false)
    }

    const removeFundingSource = async () => {
        try {
            setIsFundingSourceLoading(true);

            const filtersObject = {
                sourceId: saveFundingSourceId,
            };

            await dispatch(deleteFundingSource(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setIsFundingSourceLoading(false);
        }
        setIsRemovalModal(false);
    }
    const declineFundingSourceRequest = async () => {
        try {
            setIsFundingSourceLoading(true);

            const filtersObject = {
                sourceId: saveFundingSourceId,
            };

            await dispatch(deleteFundingSourceRequest(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setIsFundingSourceLoading(false);
        }
        setIsDeclineModal(false)
    }
    const rows = useMemo(() => {
        return fundingSourceList?.fundingSourceData?.length > 0
            ? fundingSourceList?.fundingSourceData?.map((funding) => ({
                id: funding?.userId ?? 'NA',
                userEmail: funding?.emailId ?? 'NA',
                sourceType: funding?.sourceType ?? 'NA',
                fundingSource: `Funding Source ${funding?.brandName} ending with ${funding?.lastFourDigit}`,
                isPrimary: funding?.isPrimarySource.toString() === true ? 'Yes' : 'No' ?? 'NA',
                date: funding?.deleteRequestedAt ?? 'NA',
                type: (
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: '0px' }}>
                        <MDTypography
                            fontSize="14px"
                            color={"text"}
                            sx={{ textDecoration: 'underline', cursor: 'pointer', mx: '10px', my: '0px' }}
                            onClick={(e) => {
                                setSaveFundingSourceId(funding?.id)
                                setIsRemovalModal(true);
                            }}
                        >
                            {'Approve'}
                        </MDTypography>
                        <MDTypography
                            fontSize="14px"
                            color={"text"}
                            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={(e) => {
                                setSaveFundingSourceId(funding?.id)
                                setIsDeclineModal(true);
                            }}
                        >
                            {'Reject'}
                        </MDTypography>
                    </Box>
                )
            }))
            : [];
    }, [fundingSourceList?.fundingSourceData]);

    async function fetchTransactions() {
        try {
            setLoading(true);

            const filtersObject = {
                page: currentPage + 1,
                limit: perPage,
            };

            await dispatch(getFundingSourceList(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    async function fetchDeactivateUsersList() {
        try {
            setLoading(true);

            const filtersObject = {
                page: currentPage + 1,
                limit: perPage,
            };

            await dispatch(getDeactivatedUsersList(filtersObject));
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    }

    const onFetchDataDebounced = debounce(fetchTransactions, 0);

    useEffect(() => {
        onFetchDataDebounced();

        return () => {
            onFetchDataDebounced.cancel();
        };
    }, [
        currentPage,
        perPage
    ]);
    return {
        rows,
        isLoading,
        currentPage,
        setCurrentPage,
        isRemovalModal,
        isDeclineModal,
        closeRemovalModal,
        closeDeclineModal,
        removeFundingSource,
        declineFundingSourceRequest,
        isFundingSourceLoading,
        setPerPage,
        perPage,
        totalCount: fundingSourceList?.totalCount,
        totalPage: fundingSourceList?.totalPage,
    };
}

export default useFundingSourceHook;